import { getHeaders, getNonJsonHeaders, getNoAuthHeaders } from '../../../core/api';
import { host } from '../../../config';


export function fetchCatchNews() {
  return fetch(`${host}/api/catch_news/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchCatchPartnerSpecials() {
  return fetch(`${host}/api/catch_partner_specials/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchCatchAnnouncementsConfig() {
  return fetch(`${host}/api/catch_annoncements_config/`, {
    headers: getHeaders(),
    method: 'GET',
  });
}

export function fetchBrandsDetailsConfig() {
  return fetch(`${host}/api/brandsDetail/`, {
    headers : getHeaders(),
    method : 'GET',
  });
}

export function fetchBrandsContactsConfig() {
  return fetch(`${host}/api/getBrandsContacts/`, {
    headers : getHeaders(),
    method : 'GET',
  });
}


// WEBPACK FOOTER //
// src/routes/home/modules/api.js